<div class="page">
    <div class="page-header">
        <div class="header-left">
            <mat-icon class="back-icon" routerLink="/products">arrow_back</mat-icon>
            @if (isUpdateMode) {
            <h3>{{ 'productForm.title' | translate }}</h3>
            } @else {
            <h3>{{ 'productForm.addTitle' | translate }}</h3>
            }
            @if (isUpdateMode) {
            @if (product.quantityOfSupply === 0) {
            <span class="badge badge-danger">{{ 'productForm.badge.outOfStock' | translate }}</span>
            }
            @if (product.hasPreorder) {
            <span class="badge badge-warning">{{ 'productForm.badge.preorder' | translate }}</span>
            }
            @if (product.discountLimitedUntil) {
            <span class="badge badge-danger">{{ 'productForm.badge.discountLimited' | translate }} {{ daysBetween }} {{
                'productForm.days' | translate }}</span>
            }
            }
        </div>
        @if (isUpdateMode && product.hasPreorder) {
        <div class="header-right">
            <button type="button" class="btn btn-warning" (click)="confirmSetPreorderPublished()">
                {{ 'productForm.button.setPreorderPublished' | translate }}
            </button>
        </div>
        }
    </div>

    <form novalidate [formGroup]="productForm!">
        <div class="form-and-preview">
            <div class="form-side">
                <div class="form-row">
                    <label for="title">{{ 'productForm.label.title' | translate }} <span
                            class="required">*</span></label>
                    <div class="form-input">
                        <input formControlName="title" id="title" type="text" (blur)="onTitleOrAuthorBlur()" />
                        @if (shouldShowError('title')) {
                        <span class="error">{{ 'admin.titleRequired' | translate }}</span>
                        }
                    </div>
                </div>
                <div class="form-row">
                    <label for="author">{{ 'productForm.label.author' | translate }} <span
                            class="required">*</span></label>
                    <div class="form-input">
                        <input formControlName="author" id="author" type="text" (blur)="onTitleOrAuthorBlur()" />
                        @if (shouldShowError('author')) {
                        <span class="error">{{ 'admin.authorRequired' | translate }}</span>
                        }
                    </div>
                </div>
                <div class="form-row">
                    <label for="previewTitle">{{ 'productForm.label.previewTitle' | translate }}</label>
                    <div class="form-input">
                        <input formControlName="previewTitle" id="previewTitle" type="text" />
                    </div>
                </div>
                <div class="form-row">
                    <label for="previewAuthor">{{ 'productForm.label.previewAuthor' | translate }}</label>
                    <div class="form-input">
                        <input formControlName="previewAuthor" id="previewAuthor" type="text" />
                    </div>
                </div>
                <div class="form-row">
                    <label for="routerLink">{{ 'productForm.label.routerLink' | translate }} <span
                            class="required">*</span></label>
                    <div class="form-input">
                        <input formControlName="routerLink" id="routerLink" type="text"
                            [placeholder]="'productForm.placeholder.routerLinkExample' | translate"
                            (input)="onSlugInput()" />
                        @if (shouldShowError('routerLink')) {
                        <span class="error">{{ 'productForm.error.slugInvalid' | translate }}</span>
                        }
                    </div>
                </div>
                <div class="form-row">
                    <label for="originalPrice">{{ 'productForm.label.originalPrice' | translate }} <span
                            class="required">*</span></label>
                    <div class="form-input">
                        <input formControlName="originalPrice" id="originalPrice" type="number" />
                        @if (shouldShowError('originalPrice')) {
                        <span class="error">{{ 'admin.originalPriceRequired' | translate }}</span>
                        }
                    </div>
                </div>
                <div class="form-row">
                    <label for="available">{{ 'productForm.label.available' | translate }} <span
                            class="required">*</span></label>
                    <div class="form-input">
                        <input formControlName="available" id="available" type="date" />
                        @if (shouldShowError('available')) {
                        <span class="error">{{ 'admin.availableRequired' | translate }}</span>
                        }
                    </div>
                </div>
                <div class="form-row">
                    <label for="bond">{{ 'productForm.label.bond' | translate }} <span class="required">*</span></label>
                    <div class="form-input">
                        <input formControlName="bond" id="bond" type="text" />
                        @if (shouldShowError('bond')) {
                        <span class="error">{{ 'admin.bondRequired' | translate }}</span>
                        }
                    </div>
                </div>
                <div class="form-row">
                    <label for="content">{{ 'productForm.label.content' | translate }} <span
                            class="required">*</span></label>
                    <div class="form-input">
                        <input formControlName="content" id="content" type="text" />
                        @if (shouldShowError('content')) {
                        <span class="error">{{ 'admin.contentRequired' | translate }}</span>
                        }
                    </div>
                </div>
                <div class="form-row">
                    <label for="dimension">{{ 'productForm.label.dimension' | translate }} <span
                            class="required">*</span></label>
                    <div class="form-input">
                        <input formControlName="dimension" id="dimension" type="text" />
                        @if (shouldShowError('dimension')) {
                        <span class="error">{{ 'admin.dimensionRequired' | translate }}</span>
                        }
                    </div>
                </div>
                <div class="form-row">
                    <label for="isbn">{{ 'productForm.label.isbn' | translate }} <span class="required">*</span></label>
                    <div class="form-input">
                        <input formControlName="isbn" id="isbn" type="number" />
                        @if (shouldShowError('isbn')) {
                        <span class="error">{{ 'admin.isbnRequired' | translate }}</span>
                        }
                    </div>
                </div>
                <div class="form-row">
                    <label for="quantityofsupply">{{ 'productForm.label.quantityOfSupply' | translate }} <span
                            class="required">*</span></label>
                    <div class="form-input">
                        <input formControlName="quantityofsupply" id="quantityofsupply" type="number" />
                        @if (shouldShowError('quantityofsupply')) {
                        <span class="error">{{ 'admin.quantityOfSupplyRequired' | translate }}</span>
                        }
                    </div>
                </div>
            </div>
            <div class="preview-side">
                <div class="preview-sticky">
                    <h4>{{ 'productForm.section.preview' | translate }}</h4>
                    <app-product-preview [product]="previewMaterial"
                        [extended]="!!productForm?.get('hasPreorder')?.value" />
                </div>
            </div>
        </div>

        <div class="optional-fields">
            <h4 class="section-title">{{ 'productForm.section.additionalData' | translate }}</h4>

            <div class="form-row full-width">
                <label for="html">{{ 'productForm.label.txt' | translate }} <span class="required">*</span></label>
                <app-tinymcehtmleditor id="html" name="productTxt" ngDefaultControl [html]="product.txt ?? ''"
                    [htmlForm]="htmlForm" />
            </div>

            <div class="form-row">
                <label for="subtitle">{{ 'productForm.label.subtitle' | translate }}</label>
                <div class="form-input">
                    <input formControlName="subtitle" id="subtitle" type="text" />
                </div>
            </div>
            <div class="form-row">
                <label for="translator">{{ 'productForm.label.translator' | translate }}</label>
                <div class="form-input">
                    <input formControlName="translator" id="translator" type="text" />
                </div>
            </div>
            <div class="form-row">
                <label for="illustrator">{{ 'productForm.label.illustrator' | translate }}</label>
                <div class="form-input">
                    <input formControlName="illustrator" id="illustrator" type="text" />
                </div>
            </div>

            <h4 class="section-title">{{ 'productForm.section.pricing' | translate }}</h4>

            <div class="form-row without-shadow">
                <label for="discountLimitedUntil">{{ 'productForm.label.discountLimitedUntil' | translate }}</label>
                <div class="form-input checkbox-row">
                    <mat-checkbox [(ngModel)]="discountLimitedUntil" [ngModelOptions]="{ standalone: true }" />
                    @if (isUpdateMode && product.discountLimitedUntil) {
                    <b>{{ product.discountLimitedUntil | dateUtil }}</b>
                    }
                </div>
            </div>
            <div class="form-row">
                <label for="isAvailable">{{ 'productForm.label.isAvailable' | translate }}</label>
                <div class="form-input checkbox-row">
                    <mat-checkbox formControlName="isAvailable" [disabled]="!!productForm?.get('hasPreorder')?.value" />
                </div>
            </div>
            <div class="form-row">
                <label for="isNovelty">{{ 'productForm.label.isNovelty' | translate }}</label>
                <div class="form-input checkbox-row">
                    <mat-checkbox formControlName="isNovelty" />
                </div>
            </div>
            <div class="form-row">
                <label for="webshopPrice">{{ 'productForm.label.webshopPrice' | translate }}</label>
                <div class="form-input">
                    <input #webshopPriceInput formControlName="webshopPrice" id="webshopPrice" type="number" />
                    @if (!productForm?.get('hasPreorder')?.value) {
                    <div class="checkbox-row">
                        <span>{{ 'productForm.label.active' | translate }}</span>
                        <mat-checkbox formControlName="webshopPriceActive" (change)="onChangeWebshopPriceActive()" />
                    </div>
                    }
                </div>
            </div>
            <div class="form-row">
                <label for="preorderPrice">{{ 'productForm.label.preorderPrice' | translate }}</label>
                <div class="form-input">
                    <input #preorderPriceInput formControlName="preorderPrice" id="preorderPrice" type="number" />
                    <div class="checkbox-row">
                        <span>{{ 'productForm.label.active' | translate }}</span>
                        <mat-checkbox formControlName="hasPreorder" [disabled]="isUpdateMode && !!product.hasPreorder"
                            (change)="onChangePreorderPriceActive()" />
                    </div>
                </div>
            </div>
            <div class="form-row">
                <label for="discountPrice">{{ 'productForm.label.discountPrice' | translate }}</label>
                <div class="form-input">
                    <input #discountPriceInput formControlName="discountPrice" id="discountPrice" type="number" />
                    @if (!productForm?.get('hasPreorder')?.value) {
                    <div class="checkbox-row">
                        <span>{{ 'productForm.label.active' | translate }}</span>
                        <mat-checkbox formControlName="discountPriceActive" (change)="onChangeDiscountPriceActive()" />
                    </div>
                    }
                </div>
            </div>
            <div class="form-row">
                <label for="packagePrice">{{ 'productForm.label.packagePrice' | translate }}</label>
                <div class="form-input">
                    <input #packagePriceInput formControlName="packagePrice" id="packagePrice" type="number" />
                </div>
            </div>
            <h4 class="section-title">{{ 'productForm.section.files' | translate }}</h4>
            <div class="form-row">
                <label for="file">{{ 'productForm.label.coverImage' | translate }} (.png max {{ maxImageFileSizeLabel
                    }})
                    @if (!isUpdateMode) { <span class="required">*</span> }</label>
                <div class="form-input file-row">
                    <button type="button" class="btn btn-file" onclick="document.getElementById('file').click()">
                        {{ 'productForm.button.selectCover' | translate }}
                    </button>
                    @if (addCoverFile || updateCoverFile) {
                    <span>{{ fileCover?.name }}</span>
                    } @else if (isUpdateMode && product.url) {
                    <a href="{{ product.url }}" target="_blank">{{ 'productForm.info.currentCover' | translate }}</a>
                    } @else {
                    <span>{{ 'productForm.info.noCoverSelected' | translate }}</span>
                    }
                    <mat-icon class="delete-icon" (click)="clearSelectedCoverFile()">delete_forever</mat-icon>
                    <input #fileCoverInput id="file" type="file" hidden (change)="onChangeCover($event)" />
                </div>
            </div>
            <div class="form-row">
                <label for="fileBookExtract">{{ 'productForm.label.bookExtract' | translate }} (.pdf max {{
                    maxPdfFileSizeLabel }})</label>
                <div class="form-input file-row">
                    <button type="button" class="btn btn-file"
                        onclick="document.getElementById('fileBookExtract').click()">
                        {{ 'productForm.button.selectBookExtract' | translate }}
                    </button>
                    @if (addBookExtractFile || updateBookExtractFile) {
                    <span>{{ fileBookExtract?.name }}</span>
                    } @else if (isUpdateMode && product.bookExtractUrl) {
                    <a href="{{ product.bookExtractUrl }}" target="_blank">{{ 'productForm.info.currentBookExtract' |
                        translate }}</a>
                    } @else {
                    <span>{{ 'productForm.info.noBookExtractSelected' | translate }}</span>
                    }
                    <mat-icon class="delete-icon" (click)="clearSelectedBookExtractFile()">delete_forever</mat-icon>
                    <input #fileBookExtractInput id="fileBookExtract" type="file" hidden
                        (change)="onChangeBookExtract($event)" />
                </div>
            </div>
            <h4 class="section-title">{{ 'productForm.section.pressArticles' | translate }}</h4>
            <pf-press-article [pressArticleList]="pressArticleList"
                (pressArticleListChange)="onPressArticleListChange($event)" />
            <h4 class="section-title">{{ 'productForm.section.seo' | translate }}</h4>
            <pf-meta [isUpdate]="isUpdateMode" [urlPrefix]="productUrlPrefix" />
            <div class="submit-row">
                <button type="button" class="btn btn-submit" [disabled]="!isFormValid" (click)="saveProduct()">
                    @if (isUpdateMode) {
                    {{ 'productForm.button.update' | translate }}
                    } @else {
                    {{ 'productForm.button.add' | translate }}
                    }
                </button>
            </div>
        </div>
    </form>
</div>